import React from 'react';
import Header from '../modules/header';
import axios from 'axios';

import backbutton from '../assets/images/icons/button back arrow.svg';
import quotearrow from '../assets/images/icons/button-arrow.svg';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { Link } from 'react-router-dom';

class Dates extends React.Component {
  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.state = {
      selectedDays: [],
      disabledDays: [],
      yacht: {},
      current_rate: {},
      disembarkationPort: ``,
      embarkationPort: ``,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    const yacht_id = this.props.match.params.id;
    axios
      .get(`${process.env.REACT_APP_API_URL}/yachts/${yacht_id}.json`)
      .then((response) => {
        const dates = response.data.availabilities.map((entry) => entry.dates);
        const disabled_dates = dates.length ? dates[0].map((date) => new Date(date.split('-')[2], date.split('-')[1] - 1, date.split('-')[0])) : [];
        this.setState({
          yacht: response.data.yacht,
          disabledDays: disabled_dates,
          current_rate: response.data.current_rate,
          disembarkationPort: response.data.availabilities[0] ? response.data.availabilities[0].disembarkation_port : ``,
          embarkationPort: response.data.availabilities[0] ? response.data.availabilities[0].embarkation_port : ``,
        });

        if (response.data.yacht.category === 'sale') {
          this.props.history.push('/yacht/' + response.data.yacht.id);
        }
        window.scrollTo(0, 0);
      })
      .catch();
  }

  handleDayClick(day, { selected }) {
    const { selectedDays } = this.state;
    if (selected) {
      const selectedIndex = selectedDays.findIndex((selectedDay) => DateUtils.isSameDay(selectedDay, day));
      selectedDays.splice(selectedIndex, 1);
    } else {
      selectedDays.push(day);
    }
    this.setState({ selectedDays });
  }

  handleDayMouseEnter = (_day, selected, evt) => {
    if (!selected.disabled) return;

    const { embarkationPort, disembarkationPort } = this.state;

    const tooltip = `
      <div class="tooltiptext">
        <p>Embarkation: ${embarkationPort}</p>
        <p>Disembarkation: ${disembarkationPort}</p>
      </div>
    `;

    evt.target.insertAdjacentHTML(`beforeend`, tooltip);
  };

  handleDayMouseLeave = (_day, selected, evt) => {
    if (!selected.disabled) return;

    evt.target.lastElementChild.remove();
  };

  render() {
    const yacht = this.state.yacht;
    const current_rate = this.state.current_rate;

    return (
      <div className="open_menudiv">
        <Header></Header>
        {/* Main Hero Image section  */}

        <section id="date-quote-section" className="section fix date-quote-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="row">
                  <div className="date_startdiv">
                    <div className="date-from-to">
                      <p className="year-month">
                        {new Date().toLocaleString('default', { month: 'long' })} {new Date().getFullYear()}
                      </p>
                      <p className="date-range">
                        {current_rate.week_start}th - {current_rate.week_end}th
                      </p>
                    </div>
                  </div>
                  <div className="date_enddiv">
                    <div className="price-from-div">
                      <p className="price-from"> From</p>
                      <p className="total-price">
                        €{yacht.duration_price} <span>p/week</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col" id="mobile_butndate">
                <div className="row Date_buttons">
                  <div className="date_back-btn">
                    <div className="back-btn">
                      <Link to={'/yacht/' + yacht.id}>
                        <button className="btn btn-secondary back-btn-link">
                          <img src={backbutton} className="img-responsive" alt="arrow" />
                          Back
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="date_quote_btn">
                    <div className="get-quote-btn">
                      <Link to={'/yacht/' + yacht.id + '/get-quote'}>
                        <button className="btn btn-secondary btn-theme get-quote-btn-link">
                          <span>Get A Quote</span>
                          <div className="button-arrow">
                            <img src={quotearrow} className="img-responsive" alt="arrow" />
                          </div>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* date section  */}
        <section id="calendar" className="section fix calendar-box">
          <div className="container">
            <div className="row">
              <div className="calendar">
                <div>
                  <p className="selectdate">{this.state.selectedDay ? this.state.selectedDay.toLocaleDateString() : 'Choose your destination date'}</p>
                  <DayPicker
                    selectedDays={this.state.selectedDays}
                    onDayClick={this.handleDayClick}
                    disabledDays={this.state.disabledDays}
                    onDayMouseEnter={this.handleDayMouseEnter}
                    onDayMouseLeave={this.handleDayMouseLeave}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default Dates;
